import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function GameTypesSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('gameTypes.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            选择你喜欢的麻将玩法，开启精彩对局之旅
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Link
            to="/category/guobiao-majiang"
            className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20national%20standard%20mahjong%20game%20setup%20with%20tiles%20arranged%20neatly%20on%20green%20felt%20table%2C%20traditional%20Chinese%20room%20background%20with%20warm%20lighting%2C%20clean%20composition%2C%20minimalist%20product%20photography&width=400&height=300&seq=mahjong-guobiao-01&orientation=landscape"
                alt="国标麻将"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-trophy-line text-sm"></i>
                  </span>
                  <h3 className="text-white font-heading font-semibold text-lg">
                    {t('gameTypes.guobiao')}
                  </h3>
                </div>
              </div>
            </div>
            <div className="p-5">
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t('gameTypes.guobiaoDesc')}
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                <span>了解更多</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          </Link>

          <Link
            to="/category/sichuan-majiang"
            className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Sichuan%20style%20mahjong%20game%20with%20colorful%20tiles%20on%20bamboo%20table%2C%20teahouse%20atmosphere%20with%20warm%20ambient%20light%2C%20traditional%20Chinese%20decor%2C%20cozy%20composition%2C%20minimalist%20photography&width=400&height=300&seq=mahjong-sichuan-01&orientation=landscape"
                alt="四川麻将"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-fire-line text-sm"></i>
                  </span>
                  <h3 className="text-white font-heading font-semibold text-lg">
                    {t('gameTypes.sichuan')}
                  </h3>
                </div>
              </div>
            </div>
            <div className="p-5">
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t('gameTypes.sichuanDesc')}
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                <span>了解更多</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          </Link>

          <Link
            to="/category/guangdong-majiang"
            className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cantonese%20style%20mahjong%20game%20on%20polished%20wooden%20table%20with%20ivory%20colored%20tiles%2C%20modern%20Chinese%20interior%20with%20soft%20natural%20light%2C%20elegant%20composition%2C%20minimalist%20product%20photography&width=400&height=300&seq=mahjong-guangdong-01&orientation=landscape"
                alt="广东麻将"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3">
                <div className="flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-star-line text-sm"></i>
                  </span>
                  <h3 className="text-white font-heading font-semibold text-lg">
                    {t('gameTypes.guangdong')}
                  </h3>
                </div>
              </div>
            </div>
            <div className="p-5">
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t('gameTypes.guangdongDesc')}
              </p>
              <div className="mt-4 flex items-center gap-1 text-primary-600 text-sm font-medium">
                <span>了解更多</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}